/* tslint:disable */
/* eslint-disable */
export const BASE_PATH = "https://local-map.alpha.kr.karrotmarket.com".replace(/\/+$/, "");
export * from './LocalMapServiceApi';
